// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0c43c5df","788":"1ea921aa","833":"3fe6a18b"}[chunkId] + ".chunk.js";
};